export default "/institutions/samsung-wallet.svg";